import * as React from 'react';
import { Link } from 'react-router-dom';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import * as ReqType from '../../../types/ServerRequests';
import LoginServices from '../../../services/LoginServices';
import { UserRole } from '../../../types/UserRole';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {

    /**
     * deleteCallback: l'action après la suppresion d'un user dans la liste des participant
     * @param {Presence} user
     * @returns {Promise<void>}
     */
    deleteCallback: (user: ReqType.Presence) => Promise<void>;
    /**
     * select: boolean verifant si un utilisateur figure dans la liste des participants
     */
    select?: boolean;
    /**
     * presence: structure de presence
     */
    presence: ReqType.Presence;
}

/**
 * interface State (l'état interne de la classe LineParticipantsEvent)
 */
interface State {
}

/**
 * Ce composant représente une ligne d'un tableau d'evenement.
 * Il prend en paramétres un user, une promise, un booleen et une presence.
 * Ce composant ne fais appel à aucun service.
 */
export class LineParticipantsEvent extends React.Component {
    /** le state: l'etat interne */
    state: State;
    /** le props: l'etat externe */
    props: Props;

    /**
     * construit une ligne Participants Event correspond à un utilisateur
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
    }

    /**
     * le rendu de la classe
     * @returns {JSX.element}
     */
    render() {
        const role = LoginServices.getInstance().getType();

        return (
            <tr key={this.props.presence.user_id}>
                <td scope="col">
                    <img
                        src={require('../../ProfilePage/internalComponents/photoProfile.PNG')}
                        className="img-thumbnail mx-auto d-block rounded-circle border-danger"
                        alt="Photo de profil"
                        height="80px"
                        width="80px"
                    />
                </td>
                <td scope="row">
                    <strong>
                        {
                            (this.props.presence.user.userProfile === null) ?
                                '' :
                                this.props.presence.user.userProfile.nom
                        }
                    </strong>
                </td>
                <td scope="row">
                    {
                        (this.props.presence.user.userProfile === null) ?
                            '' :
                            this.props.presence.user.userProfile.prenom
                    }
                </td>
                <td scope="row">{this.props.presence.user.username}</td>
                <td scope="row">
                    {
                        this.props.presence.presence ?
                            <h2><span className="badge badge-success">Viens</span></h2> :
                            <h2><span className="badge badge-danger">Viens pas</span></h2>
                    }
                </td>
                {role === UserRole.ADMIN.toString() ?
                    (
                        <td>
                            <Link to={'/userlist/' + this.props.presence.user_id}>
                                <button className="btn btn-default">
                                    <i className="fas fa-eye" />
                                </button>
                            </Link>
                        </td>
                    ) : undefined
                }
                {role === UserRole.ADMIN.toString() ?
                    (
                        <td>
                            {this.AddOrDelete()}
                        </td>
                    ) : undefined
                }
            </tr>);
    }

    /**
     * la suppression de l'utilisateur courant dans la liste des présences
     * @returns {JSX.Element}
     * @constructor
     */
    private AddOrDelete(): JSX.Element {

        return (
            <LoaderButton
                className="btn badge-danger "
                onClick={
                    () => {
                        return (this.props.deleteCallback(this.props.presence));
                    }
                }
                confirmation={true}
                modalTitle="Suppression de participant"
                modalBody={
                    (
                        <div>
                            Etes vous certain de vouloir retirer
                                <strong>{' ' + this.props.presence.user.username + ' '}</strong>
                            de l'évènement
                        </div>
                    )}
            >
                <i className="fas fa-minus" />
            </LoaderButton>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/LineParticipantsEvent.tsx